export default __webpack_public_path__ + "static/media/afghanistan.1d9a13f9.png";